$(function(){
    function sliderSetting(){
        var width = $(window).width();
        if(width <= 767){
            $('.slider').not('.slick-initialized').slick({
                arrows: false,
                adaptiveHeight: true,
                centerMode: true,
                centerPadding: "10%",
                dots: false,
            });
        } else {
            $('.slide.slick-initialized').slick('unslick');
        }
    }
    sliderSetting();
    $(window).resize( function() {
        sliderSetting();
    });
});

var timer = false;
var prewidth = $(window).width();
$(window).resize(function() {
    if (timer !== false) {
        clearTimeout(timer);
    }
    timer = setTimeout(function() {
        var nowWidth = $(window).width();
        if(prewidth !== nowWidth){
            location.reload();
        }
        prewidth = nowWidth;
    }, 200);
});